import { CheckCircle2, Circle, Clock, XCircle } from "lucide-react";

import { cn } from "@/lib/utils";

const STYLES = {
  success: { Icon: CheckCircle2, color: "text-green-600", title: "Run exitoso" },
  dry_run: { Icon: Clock, color: "text-amber-500", title: "Run dry-run" },
  failure: { Icon: XCircle, color: "text-red-600", title: "Run falló" },
  rolled_back: { Icon: XCircle, color: "text-red-600", title: "Run rollback" },
  skipped: { Icon: Circle, color: "text-muted-foreground", title: "Run skipped" },
} as const;

export function RunStatusIcon({ status }: { status: string | null }) {
  if (!status) {
    return (
      <span title="Sin run asociado" className="text-muted-foreground">
        —
      </span>
    );
  }
  const entry = STYLES[status as keyof typeof STYLES];
  if (!entry) {
    return (
      <span title={status} className="text-muted-foreground">
        ?
      </span>
    );
  }
  const { Icon, color, title } = entry;
  return <Icon className={cn("size-4", color)} aria-label={title} />;
}
